import React from "react";
import App from "./App";
import { StoreProvider } from "./store";
import { EventBusProvider } from "./util/useEventBus";

function PlatformPersonalization({ eventBus }) {
  return (
    <EventBusProvider eventBus={eventBus}>
      <StoreProvider>
        <App />
      </StoreProvider>
    </EventBusProvider>
  );
}

export default PlatformPersonalization;
